import type { FC } from 'react';

import RichText from '@eneco/components/RichText/RichText';
import { TrackedDialog } from '@eneco/components/TrackedDialog/TrackedDialog';
import { Heading, NavLink, Stack, Text, TextLink } from '@eneco/sparky';
import { Products_Offers_V3_TermResponseModel } from '@monorepo-types/dc';
import { Fields } from '@sitecore/types/SummaryStep';

interface Props {
  textualData?: Fields;
  offerTermsAndConditions?: Products_Offers_V3_TermResponseModel[];
}

export const TermsAndConditions: FC<Props> = ({ textualData, offerTermsAndConditions }) => (
  <>
    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.salesConditions?.conditionsParagraph?.value?.title}
        </Heading>

        <Stack.Item>
          <Text>
            <RichText
              html={textualData?.salesConditions?.conditionsParagraph?.value?.content?.split('{conditions}')[0]}
            />{' '}
            <TrackedDialog
              title={textualData?.salesConditions?.salesConditionsDialog?.value?.title}
              description={<RichText html={textualData?.salesConditions?.salesConditionsDialog?.value?.content} />}
              trigger={<TextLink>{textualData?.salesConditions?.salesConditionsDialog?.value?.triggerText}</TextLink>}>
              <Stack direction="column" gap="2">
                {offerTermsAndConditions?.map(({ text, url }) => (
                  <NavLink key={url} href={url ?? ''} target="_blank">
                    {text}
                  </NavLink>
                ))}
              </Stack>
            </TrackedDialog>{' '}
            <RichText
              html={
                textualData?.salesConditions?.conditionsParagraph?.value?.content
                  ?.split('{conditions}')[1]
                  ?.split('{prices}')[0]
              }
            />{' '}
            <RichText
              html={
                textualData?.salesConditions?.conditionsParagraph?.value?.content
                  ?.split('{conditions}')[1]
                  ?.split('{prices}')[1]
              }
            />
          </Text>
        </Stack.Item>
      </Stack>
    </Stack.Item>

    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.salesConditions?.considerationPeriodParagraph?.value?.title}
        </Heading>

        <RichText html={textualData?.salesConditions?.considerationPeriodParagraph?.value?.content} />
      </Stack>
    </Stack.Item>

    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.salesConditions?.noticePeriodParagraph?.value?.title}
        </Heading>

        <RichText html={textualData?.salesConditions?.noticePeriodParagraph?.value?.content} />
      </Stack>
    </Stack.Item>

    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.salesConditions?.extensionParagraph?.value?.title}
        </Heading>

        <RichText html={textualData?.salesConditions?.extensionParagraph?.value?.content} />
      </Stack>
    </Stack.Item>

    <Stack.Item>
      <Stack direction="column" gap="4">
        <Heading as="h3" size="XS">
          {textualData?.salesConditions?.objectionParagraph?.value?.title}
        </Heading>

        <RichText html={textualData?.salesConditions?.objectionParagraph?.value?.content} />
      </Stack>
    </Stack.Item>
  </>
);
